// extracted by mini-css-extract-plugin
export default {"productGallery":"hI-z","inQuickShop":"iI-z"};